/**
 * Constants for subscription gate module
 * Centralizes all magic numbers, colors, and repeated values
 */

// SWR configuration for subscription status checks
export const SWR_CONFIG = {
  /** Refresh every 5 minutes */
  refreshInterval: 5 * 60 * 1000,
  /** Don't revalidate on focus - prevents race condition after optimistic update */
  revalidateOnFocus: false,
  /** Revalidate when user reconnects — ensures fresh check after network loss */
  revalidateOnReconnect: true,
  /** Dedupe requests within 2 minutes to allow optimistic update to persist */
  dedupingInterval: 2 * 60 * 1000,
} as const;

// SWR cache key - shared with any other subscription status hooks for cache consistency
export const SUBSCRIPTION_STATUS_KEY = "subscription-status";

// Animation configuration for modal transitions
export const ANIMATION = {
  /** Minimum duration for opacity transitions */
  MIN_DURATION: 0.15,
  /** Maximum duration for opacity transitions */
  MAX_DURATION: 0.27,
  /** Height transition duration */
  HEIGHT_TRANSITION_DURATION: 0.27,
  /** Divisor for calculating dynamic duration based on height change */
  HEIGHT_DIFFERENCE_DIVISOR: 500,
  /** Fade in/out animation props */
  fadeInOut: {
    initial: { opacity: 0, scale: 0.96 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.96 },
    transition: { duration: 0.2, ease: [0.26, 0.08, 0.25, 1] },
  },
} as const;

// Stage identifiers
export const GATE_STAGES = {
  PAYWALL: "paywall",
  PAYMENT: "payment",
} as const;

// Z-index values for modal stacking
export const Z_INDEX = {
  MODAL_CONTENT: 100000,
} as const;

// Analytics event names
export const ANALYTICS_EVENTS = {
  gateOpened: "subscription_gate_opened",
  gateDismissed: "subscription_gate_dismissed",
  gateProductSelected: "subscription_gate_product_selected",
  gatePaymentStarted: "subscription_gate_payment_started",
} as const;
